import vertexShader from "./height-map.vert";
import fragmentShader from "./height-map.frag";
import { DoubleSide, Vector3 } from "three";

const HeightMapShader = {
  transparent: false,
  uniforms: {
    uBoxMin: {
      value: new Vector3(),
    },
    uBoxMax: {
      value: new Vector3(),
    },
  },
  vertexShader,
  fragmentShader,
  wireframe: false,
  depthWrite: false,
  depthTest: false,
  side: DoubleSide,
};

export default HeightMapShader;
